export default [
    {
        dataName: "totalPO",
        label: "PO Issued",
        icon: "ThumbsUpIcon",
        type: "statistics",
        value: ""
    },  
    {
        dataName: "totalPR",
        label: "Total PR",
        icon: "ThumbsUpIcon",
        type: "statistics",
        value: ""
    },
    {
        dataName: "closedPO",
        label: "Closed PO",
        icon: "CheckIcon",
        type: "statistics",
        value: ""
    },
    {
        dataName: "totalRejectPr",
        label: "Reject PR",
        icon: "ThumbsDownIcon",
        type: "statistics",
        value: ""
    },
    {
        dataName: "totalRejectPO",
        label: "Reject PO",
        icon: "ThumbsDownIcon",
        type: "statistics",
        value: ""
    },
  
    {
        dataName: "vendor",
        chartLabel: "Vendors Per Branch",
        barLabel: "Total Vendors",
        containerLabel: "Vendors",
        type: "horizontal-bar-chart",
        value: ""
    },
  
]